import React from 'react';
import { ShareIcon } from '@heroicons/react/outline';
import { Code } from '@components/sanity/serializers/code';
import classNames from 'classnames';

const code = `
import { SignedIn, SignedOut, SignIn } 
from "@clerk/clerk-react";

function Dashboard() {
  return (
    <main>
      <SignedIn>        
        <MyDashboard /> {/* Show dashboard */}
      </SignedIn>
      <SignedOut>        
        <SignIn /> {/* Show sign-in flow */}
      </SignedOut>
    </main>
  )
}
`;

type TProps = {
  className?: string;
  imagePosition?: 'left' | 'right';
};

export const EasyToUse: React.FC<TProps> = props => {
  const { className } = props;
  let { imagePosition } = props;
  if (!imagePosition) {
    imagePosition = 'right';
  }

  return (
    <section className={className}>
      <div className="py-8 lg:mx-auto lg:grid lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-2 lg:gap-24 lg:px-8">
        <div
          className={classNames(
            'mx-auto max-w-xl px-4 py-8 sm:px-6 lg:mx-0 lg:max-w-none lg:py-32 lg:px-0',
            imagePosition === 'right' ? 'lg:col-start-1' : 'lg:col-start-2'
          )}
        >
          <div>
            <div>
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-clerk-blue">
                <ShareIcon className="h-6 w-6 text-white" aria-hidden="true" />
              </span>
            </div>
            <div className="mt-6">
              <h2 className="text-3xl font-extrabold tracking-tight text-gray-900">
                Easy-to-use APIs
              </h2>
              <p className="text mt-4 text-gray-500">
                We obsess over every detail of our API definition,
                documentation, and helper libraries to ensure they are intuitive
                and developer-friendly.
              </p>
            </div>
          </div>
        </div>
        <div
          className={classNames(
            'mt-12 sm:mt-16 lg:mt-0',
            imagePosition === 'right' ? 'lg:col-start-2' : 'lg:col-start-1'
          )}
        >
          <Code language="jsx" theme="dark" highlightedLines={undefined}>
            {code}
          </Code>
        </div>
      </div>
    </section>
  );
};
